// extracted by mini-css-extract-plugin
export var boldText = "_8v-4";
export var checkboxContainer = "_8v-6";
export var closeIcon = "_8v-i";
export var container = "_8v-0";
export var drawer = "_8v-8";
export var drawerContent = "_8v-9";
export var extraSmallText = "_8v-5";
export var fulfillmentGroupTable = "_8v-e";
export var largeText = "_8v-3";
export var loadingSpinnerContainer = "_8v-j";
export var mediumText = "_8v-2";
export var narrow = "_8v-f";
export var notificationLink = "_8v-l";
export var packageCheckIconContainer = "_8v-7";
export var slideoutHeaderActions = "_8v-g";
export var slideoutHeaderActionsShifted = "_8v-h";
export var slideoutHeaderContainer = "_8v-a";
export var slideoutModal = "_8v-c";
export var stickyHeaderWrapper = "_8v-b";
export var table = "_8v-k";
export var tableContainer = "_8v-d";
export var tertiaryText = "_8v-1";